import { App } from 'vue'
import Chip from '@/components/chip/LpChip.vue'

Chip.install = (Vue: App) => {
  Vue.component(Chip.name, Chip)
}

export default Chip
